<template>
  <div class="input-wrapper">
    <label
      :for="inputData.name"
      v-if="data.Text && useLabel"
      :title="data.Text"
      >{{ data.Text }}</label
    >
    <input
      :id="inputData.name"
      :name="inputData.name"
      :required="inputData.required"
      type="tel"
      :placeholder="data.Text && !useLabel ? data.Text : false"
      class="input-phone"
      v-model="inputVal"
      @focus="onFocus"
      @blur="onBlur"
      pattern="\([0-9]{3}\) [0-9]{3}-[0-9]{4}"
    />
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'InputPhone',
  components: {},
  props: {
    value: String,
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
    useLabel: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      isFocused: false,
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      }
    }
  },
  computed: {
    inputVal: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal
      const parsedValue = this.formatPhone(this.inputVal)
      this.$emit('input:value-parsed', parsedValue)
      if (this.isPhoneValid(this.inputVal)) {
        this.$emit('input:isvalid', true)
        this.$emit('input', parsedValue)
      } else {
        this.$emit('input:isvalid', false)
        if (alert && this.inputVal) {
          this.alert(this.data.Text + ' is invalid')
        }
      }
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.$emit('input', this.formatPhone(this.inputVal))
      this.validate()

      this.isFocused = false
      this.$emit('input:isfocused', false)
    },
    formatPhone: function (val) {
      var raw = val || ''
      if (typeof raw !== 'string')
        raw = ''

      // Only digits are valid so strip input down to digits, including our own previously applied formatting
      raw = raw.replaceAll(/[^\d]+/g, '')
      
      // Can have at most 16 digits, including country code
      if (raw.length > 16)
        raw = raw.substring(0, 16)

      // Split number into components
      var countryCodePrefix = ''
      var countryCodeSuffix = ''
      var areaCode = ''
      var prefix = ''
      var suffix = ''

      if (raw.length > 14) {
        countryCodePrefix = raw.substring(0, raw.length - 14)
        countryCodeSuffix = raw.substring(Math.max(0, raw.length - 14), raw.length - 10)
      }
      else if (raw.length > 13) {
        countryCodePrefix = raw.substring(0, raw.length - 13)
        countryCodeSuffix = raw.substring(Math.max(0, raw.length - 13), raw.length - 10)
      }
      else if (raw.length > 10)
        countryCodeSuffix = raw.substring(0, raw.length - 10)

      if (raw.length > 7)
        areaCode = raw.substring(Math.max(0, raw.length - 10), raw.length - 7)
      if (raw.length > 4)
        prefix = raw.substring(Math.max(0, raw.length - 7), raw.length - 4)
      suffix = raw.substring(Math.max(0, raw.length - 4))

      // Reassemble components into formatted number
      var result = suffix
      if (prefix.length > 0)
        result = prefix + '-' + result
      if (areaCode.length > 0)
        result = '(' + areaCode + ') ' + result
      if (countryCodeSuffix.length > 0) {
        var countryCode = countryCodeSuffix
        if (countryCodePrefix.length > 0)
          countryCode = countryCodePrefix + '-' + countryCode

        result = '+' + countryCode + ' ' + result
      }

      return result
    },
    isPhoneValid: function (val) {
      var raw = val || ''
      if (typeof raw !== 'string')
        raw = ''

      // Get just the numeric characters
      raw = raw.replaceAll(/[^\d]+/g, '')

      // There are no 5 digit country codes, but 1, 2, 3, 4, 6, or omitted are all valid
      if (raw.length === 0 && !this.inputData.required)
        return true
      if (raw.length < 10)
        return false
      if (raw.length === 15)
        return false
      return true
    }
  },
  created: function() {
    if (this.data.Type) this.inputData.type = this.data.Type
    else this.inputData.type = PreApproveMe.getInputType('Text')
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required

    if (this.data.Value)
      this.inputVal = this.data.Value

    // Validate if pre-filled
    this.$nextTick(function () {
      if (this.value)
        this.validate()
    })

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
  },
  watch: {
    inputVal: function(value) {
      this.$emit('input:change', value)
      this.validate()
    }
  }
}
</script>

<style scoped lang="scss">
input.input-phone {
}
</style>
